import { jsx as _jsx } from "react/jsx-runtime";
import { useVariableData } from "@ploy-lib/calculation";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { commonButtonColors, commonButtonVariants } from "./ButtonCommon";
import { ButtonField } from "./Button";
export const SubmitButton = ({ label, disabled, ...props }) => {
    const { value: overrideLabel, missing } = useVariableData("Calculator", "SubmitButtonOverrideLabel");
    const { value: errorMessage } = useVariableData("Calculator", "ErrorMessage");
    return (_jsx(ButtonField, { ...props, buttonRole: "submit", disabled: disabled || errorMessage !== "", label: (!missing && overrideLabel?.toString()) || label }));
};
SubmitButton.displayName = "SubmitButton";
export const EditorSubmitButtons = identityRecordOfFieldEditorOptions({
    SubmitButton: {
        editableOptions: {
            variant: commonButtonVariants,
            color: commonButtonColors
        }
    }
});
//# sourceMappingURL=SubmitButton.js.map